import { Text } from '../../Text.js';
import { jsx } from 'react/jsx-runtime';
const variantMap = {
  h1: 'title2',
  h2: 'title2',
  h3: 'title3',
  h4: 'title4',
  h5: 'label1',
  h6: 'label2'
};
const Heading = ({
  as,
  variant,
  display = 'inline',
  color = 'foreground',
  defaultSpacingTop = 3
}) => {
  return function heading(node, children) {
    return /*#__PURE__*/jsx(Text, {
      as: as,
      color: color,
      display: display,
      variant: variant || variantMap[as],
      spacingTop: defaultSpacingTop,
      children: children
    });
  };
};
export { Heading };
//# sourceMappingURL=Heading.js.map
